module.exports = __webpack_public_path__ + "media/admin/cs_evaluation_002_sm-2abcca28.png";